import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
        homeData: 'themes/getHomeData',
        isHeaderInfo: 'layout/isHeaderInfo',
        hasOptions: 'layout/hasOptions',
        hasOptionsFormation: 'layout/hasOptionsFormation',
        hasOptionsTv: 'layout/hasOptionsTv'
    }),
  },
  methods: {
    ...mapActions('videos', ['setCurrentTheme', 'setCurrentCategory','paginateVideos','handlePagination']),
        goToHomePage(){
        this.itemClicked(0, 'trends')
        },
     async itemClicked(themeId, category = 'trends') {
      if (themeId === 0) {
        await  this.setCurrentCategory(category);
        this.$router.push({ name: 'home', params: { category } });
      }else{
        await  this.setCurrentTheme(themeId);
          this.$router.push({ name: 'theme', params: { themeId } });
      }

      if (this.isHeaderInfo) {
        this.$root.$emit('toggleNavbar');
      }
        // if(!this.isHeaderInfo && !this.hasOptionsFormation) {
        //     this.paginateVideos()
        // }
        if(this.hasOptions || this.hasOptionsTv  || this.hasOptionsFormation){
          await this.handlePagination(false)
          await  this.paginateVideos()
        }
        this.initCarousel()
      },
    async itemCategoryClicked(categoryId) {
      let category = 'trends';
      let categories = this.homeData.filter(item => {
        return categoryId === item.id;
      });
      if (categories[0]) {
        category = categories[0].category;
      }
      await this.setCurrentCategory(category);
      this.$router.push({ name: 'home', params: { category } });
        // if(!this.isHeaderInfo) {
        //     this.paginateVideos()
        // }
      if(this.hasOptions || this.hasOptionsFormation  || this.hasOptionsTv){
        await this.handlePagination(false)
        await  this.paginateVideos()
        }
        this.initCarousel()
    },
      initCarousel(){
          let carousels=document.querySelectorAll(".VueCarousel-wrapper .VueCarousel-inner");
          if(carousels && carousels.length > 0){
              carousels.forEach(cars=>{
                  cars.style.transform="translate( 0px , 0px )"
              })
          }
      },
    makeToken() {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 22; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/Mixin.js